var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgProjectTimeline(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 1440,
    height: 951,
    viewBox: "0 0 1440 951",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient",
    x1: 0.5,
    x2: 0.5,
    y2: 1,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#00ff7f"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#006934"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 1313,
    height: 31,
    fill: "none"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_7042",
    "data-name": "Group 7042",
    transform: "translate(-240 -10199)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_124",
    "data-name": "Rectangle 124",
    width: 1440,
    height: 951,
    rx: 15,
    transform: "translate(240 10199)",
    fill: "#16161a"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Intersection_2",
    "data-name": "Intersection 2",
    d: "M10248,21271a15,15,0,0,1-15-15V20985.77c165.389,42.141,294.954,149.7,342.417,285.229Z",
    transform: "translate(-9993 -10121)",
    opacity: 0.15,
    fill: "url(#linear-gradient)"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_6959",
    "data-name": "Group 6959",
    transform: "translate(0 -180)"
  }, /*#__PURE__*/React.createElement("line", {
    id: "Line_28",
    "data-name": "Line 28",
    y2: 706.5,
    transform: "translate(334.5 10623.5)",
    fill: "none",
    stroke: "#fff",
    strokeWidth: 1,
    opacity: 0.1
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_28-2",
    "data-name": "Line 28",
    y2: 706.5,
    transform: "translate(513.5 10623.5)",
    fill: "none",
    stroke: "#fff",
    strokeWidth: 1,
    opacity: 0.1
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_28-3",
    "data-name": "Line 28",
    y2: 706.5,
    transform: "translate(692.5 10623.5)",
    fill: "none",
    stroke: "#fff",
    strokeWidth: 1,
    opacity: 0.1
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_28-4",
    "data-name": "Line 28",
    y2: 706.5,
    transform: "translate(871.5 10623.5)",
    fill: "none",
    stroke: "#fff",
    strokeWidth: 1,
    opacity: 0.1
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_28-5",
    "data-name": "Line 28",
    y2: 706.5,
    transform: "translate(1050.5 10623.5)",
    fill: "none",
    stroke: "#fff",
    strokeWidth: 1,
    opacity: 0.1
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_28-6",
    "data-name": "Line 28",
    y2: 706.5,
    transform: "translate(1229.5 10623.5)",
    fill: "none",
    stroke: "#fff",
    strokeWidth: 1,
    opacity: 0.1
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_28-7",
    "data-name": "Line 28",
    y2: 706.5,
    transform: "translate(1408.5 10623.5)",
    fill: "none",
    stroke: "#fff",
    strokeWidth: 1,
    opacity: 0.1
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_28-8",
    "data-name": "Line 28",
    y2: 706.5,
    transform: "translate(1587.5 10623.5)",
    fill: "none",
    stroke: "#fff",
    strokeWidth: 1,
    opacity: 0.1
  })), /*#__PURE__*/React.createElement("g", {
    id: "Component_12_1",
    "data-name": "Component 12 \\u2013 1",
    transform: "translate(309 10266.998)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_125",
    "data-name": "Rectangle 125",
    width: 198,
    height: 73,
    rx: 9,
    transform: "translate(0 0.002)",
    fill: "#1a1d24"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Intersection_1",
    "data-name": "Intersection 1",
    d: "M9580,20360a19.955,19.955,0,0,1-7-1.26V20343a9,9,0,0,1,9-9h18.084a20.013,20.013,0,0,1-19.083,26Z",
    transform: "translate(-9573 -20333.998)",
    fill: "url(#linear-gradient)"
  }), /*#__PURE__*/React.createElement("text", {
    id: "_1_Week",
    "data-name": "1 Week",
    transform: "translate(99 46.002)",
    fill: "#fff",
    fontSize: 22,
    fontFamily: "Access-Bold, Access",
    fontWeight: 700,
    opacity: 0.9
  }, /*#__PURE__*/React.createElement("tspan", {
    x: -34.485,
    y: 0
  }, "1 Week"))), /*#__PURE__*/React.createElement("g", {
    id: "Component_12_2",
    "data-name": "Component 12 \\u2013 2",
    transform: "translate(762 10266.998)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_125-2",
    "data-name": "Rectangle 125",
    width: 198,
    height: 73,
    rx: 9,
    transform: "translate(0 0.002)",
    fill: "#1a1d24"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Intersection_1-2",
    "data-name": "Intersection 1",
    d: "M9580,20360a19.955,19.955,0,0,1-7-1.26V20343a9,9,0,0,1,9-9h18.084a20.013,20.013,0,0,1-19.083,26Z",
    transform: "translate(-9573 -20333.998)",
    fill: "url(#linear-gradient)"
  }), /*#__PURE__*/React.createElement("text", {
    id: "_2_Week",
    "data-name": "2 Week",
    transform: "translate(99 46.002)",
    fill: "#fff",
    fontSize: 22,
    fontFamily: "Access-Bold, Access",
    fontWeight: 700,
    opacity: 0.9
  }, /*#__PURE__*/React.createElement("tspan", {
    x: -36.311,
    y: 0
  }, "2 Week"))), /*#__PURE__*/React.createElement("g", {
    id: "Component_12_3",
    "data-name": "Component 12 \\u2013 3",
    transform: "translate(1215 10266.998)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_125-3",
    "data-name": "Rectangle 125",
    width: 198,
    height: 73,
    rx: 9,
    transform: "translate(0 0.002)",
    fill: "#1a1d24"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Intersection_1-3",
    "data-name": "Intersection 1",
    d: "M9580,20360a19.955,19.955,0,0,1-7-1.26V20343a9,9,0,0,1,9-9h18.084a20.013,20.013,0,0,1-19.083,26Z",
    transform: "translate(-9573 -20333.998)",
    fill: "url(#linear-gradient)"
  }), /*#__PURE__*/React.createElement("text", {
    id: "_3_Week",
    "data-name": "3 Week",
    transform: "translate(99 46.002)",
    fill: "#fff",
    fontSize: 22,
    fontFamily: "Access-Bold, Access",
    fontWeight: 700,
    opacity: 0.9
  }, /*#__PURE__*/React.createElement("tspan", {
    x: -36.465,
    y: 0
  }, "3 Week"))), /*#__PURE__*/React.createElement("g", {
    id: "Repeat_Grid_1",
    "data-name": "Repeat Grid 1",
    transform: "translate(304 10405)",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(-313 -10563)"
  }, /*#__PURE__*/React.createElement("text", {
    id: "MON",
    transform: "translate(340 10588)",
    fill: "#fff",
    fontSize: 22,
    fontFamily: "Access-Bold, Access",
    fontWeight: 700,
    opacity: 0.9
  }, /*#__PURE__*/React.createElement("tspan", {
    x: -26.961,
    y: 0
  }, "MON"))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(-134 -10563)"
  }, /*#__PURE__*/React.createElement("text", {
    id: "TUE",
    transform: "translate(340 10588)",
    fill: "#fff",
    fontSize: 22,
    fontFamily: "Access-Bold, Access",
    fontWeight: 700,
    opacity: 0.9
  }, /*#__PURE__*/React.createElement("tspan", {
    x: -19.789,
    y: 0
  }, "TUE"))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(45 -10563)"
  }, /*#__PURE__*/React.createElement("text", {
    id: "WED",
    transform: "translate(340 10588)",
    fill: "#fff",
    fontSize: 22,
    fontFamily: "Access-Bold, Access",
    fontWeight: 700,
    opacity: 0.9
  }, /*#__PURE__*/React.createElement("tspan", {
    x: -24.717,
    y: 0
  }, "WED"))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(224 -10563)"
  }, /*#__PURE__*/React.createElement("text", {
    id: "THU",
    transform: "translate(340 10588)",
    fill: "#fff",
    fontSize: 22,
    fontFamily: "Access-Bold, Access",
    fontWeight: 700,
    opacity: 0.9
  }, /*#__PURE__*/React.createElement("tspan", {
    x: -21.681,
    y: 0
  }, "THU"))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(403 -10563)"
  }, /*#__PURE__*/React.createElement("text", {
    id: "FRI",
    transform: "translate(340 10588)",
    fill: "#fff",
    fontSize: 22,
    fontFamily: "Access-Bold, Access",
    fontWeight: 700,
    opacity: 0.9
  }, /*#__PURE__*/React.createElement("tspan", {
    x: -15.862,
    y: 0
  }, "FRI"))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(582 -10563)"
  }, /*#__PURE__*/React.createElement("text", {
    id: "MON-2",
    "data-name": "MON",
    transform: "translate(340 10588)",
    fill: "#fff",
    fontSize: 22,
    fontFamily: "Access-Bold, Access",
    fontWeight: 700,
    opacity: 0.9
  }, /*#__PURE__*/React.createElement("tspan", {
    x: -26.961,
    y: 0
  }, "MON"))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(761 -10563)"
  }, /*#__PURE__*/React.createElement("text", {
    id: "TUE-2",
    "data-name": "TUE",
    transform: "translate(340 10588)",
    fill: "#fff",
    fontSize: 22,
    fontFamily: "Access-Bold, Access",
    fontWeight: 700,
    opacity: 0.9
  }, /*#__PURE__*/React.createElement("tspan", {
    x: -19.789,
    y: 0
  }, "TUE"))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(940 -10563)"
  }, /*#__PURE__*/React.createElement("text", {
    id: "WED-2",
    "data-name": "WED",
    transform: "translate(340 10588)",
    fill: "#fff",
    fontSize: 22,
    fontFamily: "Access-Bold, Access",
    fontWeight: 700,
    opacity: 0.9
  }, /*#__PURE__*/React.createElement("tspan", {
    x: -24.717,
    y: 0
  }, "WED")))), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_129",
    "data-name": "Rectangle 129",
    width: 527,
    height: 76,
    rx: 10,
    transform: "translate(328 10556)",
    fill: "#1a1d24"
  }), /*#__PURE__*/React.createElement("text", {
    id: "Strategy",
    transform: "translate(438 10604)",
    fill: "#6de4f2",
    fontSize: 22,
    fontFamily: "Access-Bold, Access",
    fontWeight: 700,
    opacity: 0.9
  }, /*#__PURE__*/React.createElement("tspan", {
    x: -44.099,
    y: 0
  }, "Strategy")), /*#__PURE__*/React.createElement("g", {
    id: "Group_6956",
    "data-name": "Group 6956",
    transform: "translate(-6 -160)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Polygon_1",
    "data-name": "Polygon 1",
    d: "M14.086,1.414a2,2,0,0,1,2.828,0L29.586,14.086a2,2,0,0,1,0,2.828L16.914,29.586a2,2,0,0,1-2.828,0L1.414,16.914a2,2,0,0,1,0-2.828Z",
    transform: "translate(769 10739)",
    fill: "#65d1dd",
    opacity: 0.08
  }), /*#__PURE__*/React.createElement("path", {
    id: "Polygon_2",
    "data-name": "Polygon 2",
    d: "M11.086,1.414a2,2,0,0,1,2.828,0l9.672,9.672a2,2,0,0,1,0,2.828l-9.672,9.672a2,2,0,0,1-2.828,0L1.414,13.914a2,2,0,0,1,0-2.828Z",
    transform: "translate(772 10742)",
    fill: "#65d1dd",
    opacity: 0.35
  }), /*#__PURE__*/React.createElement("path", {
    id: "Polygon_3",
    "data-name": "Polygon 3",
    d: "M7.086,1.414a2,2,0,0,1,2.828,0l5.672,5.672a2,2,0,0,1,0,2.828L9.914,15.586a2,2,0,0,1-2.828,0L1.414,9.914a2,2,0,0,1,0-2.828Z",
    transform: "translate(776 10746)",
    fill: "#65d1dd",
    opacity: 0.7
  })), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_129-2",
    "data-name": "Rectangle 129",
    width: 698,
    height: 76,
    rx: 10,
    transform: "translate(328 10667)",
    fill: "#1a1d24"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_130",
    "data-name": "Rectangle 130",
    width: 844,
    height: 76,
    rx: 10,
    transform: "translate(742 10793)",
    fill: "#1a1d24"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_131",
    "data-name": "Rectangle 131",
    width: 486,
    height: 76,
    rx: 10,
    transform: "translate(742 10904)",
    fill: "#1a1d24"
  }), /*#__PURE__*/React.createElement("text", {
    id: "Research",
    transform: "translate(439 10715)",
    fill: "#f26d6d",
    fontSize: 22,
    fontFamily: "Access-Bold, Access",
    fontWeight: 700,
    opacity: 0.9
  }, /*#__PURE__*/React.createElement("tspan", {
    x: -44.814,
    y: 0
  }, "Research")), /*#__PURE__*/React.createElement("text", {
    id: "UX",
    transform: "translate(845 10841)",
    fill: "#00d176",
    fontSize: 22,
    fontFamily: "Access-Bold, Access",
    fontWeight: 700,
    opacity: 0.9
  }, /*#__PURE__*/React.createElement("tspan", {
    x: -14.575,
    y: 0
  }, "UX")), /*#__PURE__*/React.createElement("text", {
    id: "UI_Design",
    "data-name": "UI Design",
    transform: "translate(877 10952)",
    fill: "#f6df6b",
    fontSize: 22,
    fontFamily: "Access-Bold, Access",
    fontWeight: 700,
    opacity: 0.9
  }, /*#__PURE__*/React.createElement("tspan", {
    x: -46.596,
    y: 0
  }, "UI Design")), /*#__PURE__*/React.createElement("g", {
    id: "Group_6956-2",
    "data-name": "Group 6956",
    transform: "translate(162 -49)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Polygon_1-2",
    "data-name": "Polygon 1",
    d: "M14.086,1.414a2,2,0,0,1,2.828,0L29.586,14.086a2,2,0,0,1,0,2.828L16.914,29.586a2,2,0,0,1-2.828,0L1.414,16.914a2,2,0,0,1,0-2.828Z",
    transform: "translate(769 10739)",
    fill: "#dc6465",
    opacity: 0.08
  }), /*#__PURE__*/React.createElement("path", {
    id: "Polygon_2-2",
    "data-name": "Polygon 2",
    d: "M11.086,1.414a2,2,0,0,1,2.828,0l9.672,9.672a2,2,0,0,1,0,2.828l-9.672,9.672a2,2,0,0,1-2.828,0L1.414,13.914a2,2,0,0,1,0-2.828Z",
    transform: "translate(772 10742)",
    fill: "#dc6465",
    opacity: 0.35
  }), /*#__PURE__*/React.createElement("path", {
    id: "Polygon_3-2",
    "data-name": "Polygon 3",
    d: "M7.086,1.414a2,2,0,0,1,2.828,0l5.672,5.672a2,2,0,0,1,0,2.828L9.914,15.586a2,2,0,0,1-2.828,0L1.414,9.914a2,2,0,0,1,0-2.828Z",
    transform: "translate(776 10746)",
    fill: "#dc6465",
    opacity: 0.7
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_6957",
    "data-name": "Group 6957",
    transform: "translate(729 77)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Polygon_1-3",
    "data-name": "Polygon 1",
    d: "M14.086,1.414a2,2,0,0,1,2.828,0L29.586,14.086a2,2,0,0,1,0,2.828L16.914,29.586a2,2,0,0,1-2.828,0L1.414,16.914a2,2,0,0,1,0-2.828Z",
    transform: "translate(769 10739)",
    fill: "#00d176",
    opacity: 0.08
  }), /*#__PURE__*/React.createElement("path", {
    id: "Polygon_2-3",
    "data-name": "Polygon 2",
    d: "M11.086,1.414a2,2,0,0,1,2.828,0l9.672,9.672a2,2,0,0,1,0,2.828l-9.672,9.672a2,2,0,0,1-2.828,0L1.414,13.914a2,2,0,0,1,0-2.828Z",
    transform: "translate(772 10742)",
    fill: "#00d176",
    opacity: 0.35
  }), /*#__PURE__*/React.createElement("path", {
    id: "Polygon_3-3",
    "data-name": "Polygon 3",
    d: "M7.086,1.414a2,2,0,0,1,2.828,0l5.672,5.672a2,2,0,0,1,0,2.828L9.914,15.586a2,2,0,0,1-2.828,0L1.414,9.914a2,2,0,0,1,0-2.828Z",
    transform: "translate(776 10746)",
    fill: "#00d176",
    opacity: 0.7
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_6958",
    "data-name": "Group 6958",
    transform: "translate(1140 10927)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Polygon_1-4",
    "data-name": "Polygon 1",
    d: "M14.086,1.414a2,2,0,0,1,2.828,0L29.586,14.086a2,2,0,0,1,0,2.828L16.914,29.586a2,2,0,0,1-2.828,0L1.414,16.914a2,2,0,0,1,0-2.828Z",
    fill: "#f6df6b",
    opacity: 0.08
  }), /*#__PURE__*/React.createElement("path", {
    id: "Polygon_2-4",
    "data-name": "Polygon 2",
    d: "M11.086,1.414a2,2,0,0,1,2.828,0l9.672,9.672a2,2,0,0,1,0,2.828l-9.672,9.672a2,2,0,0,1-2.828,0L1.414,13.914a2,2,0,0,1,0-2.828Z",
    transform: "translate(3 3)",
    fill: "#f6df6b",
    opacity: 0.35
  }), /*#__PURE__*/React.createElement("path", {
    id: "Polygon_3-4",
    "data-name": "Polygon 3",
    d: "M7.086,1.414a2,2,0,0,1,2.828,0l5.672,5.672a2,2,0,0,1,0,2.828L9.914,15.586a2,2,0,0,1-2.828,0L1.414,9.914a2,2,0,0,1,0-2.828Z",
    transform: "translate(7 7)",
    fill: "#f6df6b",
    opacity: 0.7
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgProjectTimeline);
export default __webpack_public_path__ + "static/media/project_timeline.f8dbeaa8d153513e9af9aee5424ca51e.svg";
export { ForwardRef as ReactComponent };